import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const ErrorIcon = styled.span(props => ({
    color: theme(props).semanticColors.danger.color,
}));

export const WarningIcon = styled.span(props => ({
    color: theme(props).semanticColors.warning.color,
}));
